<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-card outlined width="450" class="mt-10">
          <v-card-title>Login</v-card-title>
          <v-card-text>
            <v-text-field
              @keyup.enter="login()"
              v-model="email"
              label="Email"
              prepend-inner-icon="mdi-email-outline"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              @keyup.enter="login()"
              v-model="password"
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show_password ? 'text' : 'password'"
              label="Password"
              @click:append="show_password = !show_password"
              prepend-inner-icon="mdi-lock-outline"
              outlined
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-spacer/>
            <v-btn outlined @click="forgotPasswordInitial()">Forgot password</v-btn>
            <v-btn color="primary" @click="login()">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Forgot Password Modal -->
    <v-dialog v-model="forgotPasswordModel" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Forgot Password
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-form ref="form" v-model="valid" class="mt-5">
            <v-text-field
              v-model="email_forgot"
              label="Email"
              :rules="emailRules"
              required
              outlined
              dense
              @keyup.enter="forgotPasswordFN()"
              hint="Kindly click submit don't press enter!"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="forgotPasswordModel = false">
            Cancel
          </v-btn>

          <v-btn color="primary" :disabled="!valid" @click="forgotPasswordFN()">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LoginComponent",
  data: () => ({
    show_password: false,
    email: null,
    password: null,
    forgotPasswordModel: false,
    email_forgot: null,
    valid: false,
    emailRules: [
      v => !!v || 'Email is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
  }),
  mounted() {
    document.title = "DG Tasks - Login";
    this.checkLogin();
  },
  computed: {
    ...mapGetters({
      user: "auth/get_user",
    }),
  },
  methods: {
    showSnackBar(message) {
      this.$store.commit(
        "auth/setMessage",
        { show: true, message: message },
        { root: 1 }
      );
    },
    checkLogin() {
      if (Object.keys(this.user).length !== 0) {
        this.$router.push({ name: "Dashboard" });
      }
    },
    async login() {
      let payload = {
        email: this.email,
        password: this.password,
      };
      await this.$axios.post("api/login", payload).then(({ data }) => {
        if (data.response) {
          this.$toast.success(data.message);
          this.$store.dispatch("auth/set_user", data.user);
          this.$store.dispatch("auth/set_token", data.token);
          // Company wall-clock reference, configured API-side so it is not
          // baked into each frontend build.
          this.$store.dispatch("settings/setBaselineTimezone", data.baseline_timezone);
          // Display timezone / clock format belong to the account, not the
          // machine, so this overwrites whatever the last user on this browser
          // had rather than merging with it.
          this.$store.dispatch("settings/adoptUserPreferences", data.user);
          this.$store.dispatch("auth/set_roles", data.roles);
          this.$store.dispatch("tasks/set_priorities", data.priorities);
          this.$store.dispatch("tasks/set_statuses", data.statuses);
          this.$store.dispatch(
            "meetings/set_meeting_statuses",
            data.meeting_statuses
          );
          this.$store.dispatch(
            "projects/set_project_statuses",
            data.project_statuses
          );
          this.$router.go({ name: "Dashboard" });
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    forgotPasswordInitial(){
      this.forgotPasswordModel = true
    },
    async forgotPasswordFN(){
      this.$toast.info('Please wait')
      const response = await this.$axios.post('api/forgot-password', {email: this.email_forgot})
      const {data} = response
      if(data){
        this.forgotPasswordModel = false
        this.$toast.success("Forgot Password instruction has been sent to your email!");
      }
    }
  },
};
</script>

<style scoped></style>
